import React from 'react'
import * as S from './styles'

//icons
import copy from '../../../assets/icons/copy.svg'

//utils
import cogoToast from 'cogo-toast'

interface IProps {
	code: string
}

function CopyCodeBar({ code }: IProps) {
	function copyCodeToClipboard() {
		navigator.clipboard.writeText(code)
		cogoToast.info('Codigo copiado para clipboard')
	}

	return (
		<S.CopyCodeContainer onClick={copyCodeToClipboard}>
			<S.CopyCode>{code || ''}</S.CopyCode>
			<S.CopyIcon src={copy} />
		</S.CopyCodeContainer>
	)
}

export { CopyCodeBar }

